import { useContext, useState } from 'react';
import ModalCover from 'components/shared/modal/ModalCover';
import ThemeContext from 'config/context/themeContext';
import styles from './ExportDataModal.module.css';

const ExportDataModal = ({ onClose, onConfirm }) => {
    const { dark } = useContext(ThemeContext);
    const [format, setFormat] = useState('json');

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm(format);
        }
        if (onClose) {
            onClose();
        }
    };

    return (
        <ModalCover size="sm" closeOnOverlay={true}>
            <div className={`${styles.export_modal} ${dark ? styles.dark : ''}`}>
                <h3>Export data</h3>
                <p>Select the format in which you want to export the selected rows.</p>

                <div className={styles.options}>
                    <label className={`${styles.option} ${format === 'json' ? styles.selected : ''}`}>
                        <div className={styles.option_input_container}>
                            <input
                                type="radio"
                                name="export-format"
                                value="json"
                                checked={format === 'json'}
                                onChange={() => setFormat('json')}
                            />
                            <span className={styles.option_label}>JSON</span>
                        </div>
                        <span className={styles.option_description}>
                            Structured export with all fields in a JSON array.
                        </span>
                    </label>

                    <label className={`${styles.option} ${format === 'csv' ? styles.selected : ''}`}>
                        <div className={styles.option_input_container}>
                            <input
                                type="radio"
                                name="export-format"
                                value="csv"
                                checked={format === 'csv'}
                                onChange={() => setFormat('csv')}
                            />
                            <span className={styles.option_label}>CSV</span>
                        </div>
                        <span className={styles.option_description}>
                            Comma-separated values suitable for spreadsheets.
                        </span>
                    </label>

                    <label className={`${styles.option} ${format === 'xml' ? styles.selected : ''}`}>
                        <div className={styles.option_input_container}>
                            <input
                                type="radio"
                                name="export-format"
                                value="xml"
                                checked={format === 'xml'}
                                onChange={() => setFormat('xml')}
                            />
                            <span className={styles.option_label}>XML</span>
                        </div>
                        <span className={styles.option_description}>
                            Hierarchical XML representation of the selected rows.
                        </span>
                    </label>
                </div>

                <div className={styles.actions}>
                    <button onClick={onClose}>
                        Cancel
                    </button>
                    <button onClick={handleConfirm}>
                        Export
                    </button>
                </div>
            </div>
        </ModalCover>
    );
};

export default ExportDataModal;

